import ReactTooltip from 'react-tooltip';

const MenuElements = ({ menuElements }) =>
  menuElements.map((menuElement, index) => (
    <li
      {...menuElement.attrs}
      className={`${menuElement.attrs.className} popdown-item`}
      onClick={menuElement.clickEvent}
      key={index}
      style={{
        width: '100%',
        padding: '7px 0 7px 0',
        margin: '0 2vw 0 0',
        fontSize: '0.9rem',
        color: '#5c5c5c',
      }}
    >
      {menuElement.faIcon ? (
        <i
          className={`${menuElement.faIcon}`}
          style={{ display: 'inline-block', paddingRight: '5%' }}
        />
      ) : null}
      <span
        style={{
          display: 'inline-block',
          lineHeight: '18px',
          margin: '5px',
        }}
      >
        {menuElement.text}
      </span>
    </li>
  ));

const PopdownMenu = ({
  dropdownId,
  afterHide,
  afterShow,
  menuProps,
  menuElements,
}) => (
  <ReactTooltip
    arrowColor={'transparent'}
    key={`tooltip-${dropdownId}`}
    id={`dropdown-${dropdownId}`}
    ariaHaspopup="true"
    role="dropdown"
    place="bottom"
    effect="solid"
    type="light"
    globalEventOff="click"
    afterShow={afterShow}
    afterHide={afterHide}
  >
    <ul
      {...menuProps}
      style={{ pointerEvents: 'all' }}
      key={`ul-${dropdownId}`}
    >
      <MenuElements menuElements={menuElements} />
    </ul>
  </ReactTooltip>
);

export default PopdownMenu;
